import "./Banner.scss";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Product from "./Json";
import Typewriter from "typewriter-effect";

const Banner = () => {
  return (
    <section className="categories-slider">
      <div className="studentb">
        <Typewriter
          options={{
            strings: ["<span>Our Students</span>", "Doing Great Internships"],
            autoStart: true,
            loop: true,
            delay: 60,
            deleteSpeed: 30,
          }}
        />
      </div>

      <Carousel
        responsive={{
          desktop: { breakpoint: { max: 3000, min: 1024 }, items: 7 },
          tablet: { breakpoint: { max: 1024, min: 464 }, items: 4 },
          mobile: { breakpoint: { max: 464, min: 0 }, items: 3 },
        }}
        autoPlay={true}
        autoPlaySpeed={2500}
        infinite={true}
        swipeable={true}
        draggable={false}
        removeArrowOnDeviceType={["tablet", "mobile"]}
        pauseOnHover={false}
        slidesToSlide={1}
        className="banner-slide"
      >
        {Product.map((Item) => (
          <div key={Item.userid} className="borderb">
            <div className="img-wrapper">
              <img
                src={Item.student}
                alt={Item.studentname}
                className="imageb"
                loading="lazy"
              />
            </div>
            <div className="nameb">{Item.studentname}</div>
            <div className="positionb">— {Item.title} —</div>
          </div>
        ))}
      </Carousel>
    </section>
  );
};

export default Banner;
